module.exports = __webpack_public_path__ + "img/facebook-color.25de855c.svg";